// extracted by mini-css-extract-plugin
export default {"input":"QSRR2F","input--form":"JtWFg6","inputForm":"JtWFg6","input--empty":"FuCndG","inputEmpty":"FuCndG","input--error":"DDBjZ2","inputError":"DDBjZ2","msgvalid":"nA08CS"};